<div class="fc-signup-error">
    <div class="fc-signup-error-frame">
        <div class="fc-signup-error-frame-inner">
            <img src="assets/img/fc_singup_error_icon.svg" />
            <div class="fc-signup-error-frame-inner-body">
                <div class="fc-signup-error-frame-inner-body-header">
                    {{ text.header | translate }}
                </div>
                <div class="fc-signup-error-frame-inner-body-description">
                    {{ text.description | translate }}
                </div>
                <ng-container *ngIf="redirectToLogin; else actionButton">
                    <div class="fc-signup-error-frame-inner-body-button">
                        <button
                            fcp-filled-button
                            (click)="goToLogin()"
                            data-e2e-hook="signup-completed-error-retry-button"
                        >
                            {{ 'TEXT_CLOSE' | translate }}
                        </button>
                    </div>
                </ng-container>
                <ng-template #actionButton>
                    <div class="fc-signup-error-frame-inner-body-button" *ngIf="actionButtonLabel">
                        <button
                            fcp-filled-button
                            (click)="onActionButtonClick()"
                            data-e2e-hook="signup-completed-error-retry-button"
                        >
                            {{ actionButtonLabel | translate }}
                        </button>
                    </div>
                    <div class="fc-signup-error-frame-inner-body-contact">
                        {{ 'SIGNUP.ACCOUNT_VERIFICATION.ERROR.CONTACT' | translate }}
                        <div class="fc-signup-error-frame-inner-body-contact-email">{{ supportEmail }}</div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
